<template>
  <div
    ref="cardElement"
    class="card-empty position-relative p-t-16 p-b-16 p-x-24"
    :class="{ 'focused-item': isFocused }"
  >
    <img
      :src="
        isFocused
          ? require('../../../assets/Card Gradient.svg')
          : require('../../../assets/Card Gradient Inactive.svg')
      "
      alt="Gradient"
      class="image-filler position-absolute h-100"
    />

    <div class="position-relative" style="z-index: 1">
      <div class="d-flex justify-content-between align-items-start">
        <p
          :class="{ 'text-not-focused': !isFocused }"
          class="f-Overpass f-w-600 f-16 my-1"
        >
          {{ namaOutlet }}
        </p>
        <img
          :src="
            isFocused
              ? require('../../../assets/icons/circle-info.svg')
              : require('../../../assets/icons/circle-info-inactive.svg')
          "
          @click="handleIconClick"
          alt="circle-info"
        />
      </div>
      <p
        :class="{ 'text-not-focused': !isFocused }"
        class="f-Overpass f-w-400 f-12 my-0"
      >
        Terdaftar pada
        {{ this.$moment(tanggalDibuat).format("L") }}
      </p>
      <p
        :class="{ 'text-not-focused': !isFocused }"
        class="f-Overpass f-w-400 f-12 my-0"
      >
        Sebagai
        <span
          :class="{ 'text-not-focused': !isFocused }"
          class="f-Overpass f-w-600 f-12"
        >
          {{ namaAkun }}</span
        >
      </p>
      <p
        :class="{ 'text-not-focused': !isFocused }"
        class="f-Overpass f-w-700 f-24 mt-2 my-0"
      >
        {{ displaySaldo(saldoAkun) }}
      </p>
    </div>
    <modalOutlet
      ref="modalOutlet"
      :kota="kotaOutlet"
      :latitude-outlet="latitudeOutlet"
      :longitude-outlet="longtitudeOutlet"
      :nama="namaOutlet"
    />
  </div>
</template>

<script>
import modalOutlet from "./modal/modalOutlet.vue";

export default {
  name: "balanceCard",
  components: {
    modalOutlet,
  },

  props: {
    namaOutlet: String,
    kotaOutlet: String,
    latitudeOutlet: Number,
    longtitudeOutlet: Number,
    tanggalDibuat: String,
    namaAkun: String,
    saldoAkun: Number,
    index: Number,
  },

  data() {
    return {
      isFocused: false,
    };
  },

  mounted() {
    const options = {
      root: null,
      threshold: 0.5,
    };

    const observer = new IntersectionObserver(this.handleIntersection, options);
    observer.observe(this.$refs.cardElement);
  },

  methods: {
    handleIconClick() {
      this.$refs.modalOutlet.open();
    },

    handleIntersection(entries) {
      const entry = entries[0];
      // console.log(entry.isIntersecting);
      this.isFocused = entry.isIntersecting;
    },

    displaySaldo(money) {
      const formattedMoney = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(money);

      return formattedMoney.replace(/\.00$/, "");
    },
  },
};
</script>

<style scoped>
.card-empty {
  width: -webkit-fill-available;
  height: 150px;
  border-radius: 16px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  color: #fff;
  flex: 0 0 auto;
  scroll-snap-align: start;
  margin-right: 10px;
  background: linear-gradient(
    150deg,
    #c8d0dd -3.8%,
    rgba(111, 114, 135, 0.76) 127.29%
  );
  transition: background 5s ease-in 5s, opacity 5s ease-in 5s;
}

.card-empty.focused-item {
  background: linear-gradient(
    150deg,
    #206cfe -3.8%,
    rgba(0, 38, 148, 0.76) 127.29%
  );
  transition: background 5s ease-in 5s;
}

.image-filler {
  top: 0;
  right: 0;
  border-radius: 16px;
  transition: opacity 5s ease 5s;
}

.text-not-focused {
  color: #212121;
}
</style>
